import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BRANDALL, BRAND } from "../../services/actions";
import { Box, Grid, Button, Card, TextField, Pagination } from "@mui/material";
import { BsFilePlusFill } from "react-icons/bs";
import RDialog from "../extra/RDialog";
import Form from "./Form";
import ActionBar from "../extra/ActionBar";
import InfoCard from "../extra/InfoCard";

export default function View() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const ref2 = React.useRef();

  const brandallState = useSelector((state) => state?.brandallState);
  const brandState = useSelector((state) => state?.brandState);
  const user = useSelector((state) => state?.loginState?.auth);
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchBrands = (page = 0) => {
    const url = page === 0 ? `camerabrand/${page}/` : `camerabrand/?page=${page}`; // pass page number
    dispatch({ type: `${BRANDALL}_GET`, payload: url });
  };


  React.useEffect(() => {
    //dispatch({ type: `${BRANDALL}_GET`, payload: 0 });
    fetchBrands(0);
  }, []);
  React.useEffect(() => {
    fetchBrands(page);
  }, [page]);


  React.useEffect(() => {
    if (brandState?.success) {
      setOpen(false);
    }
    dispatch({ type: `${BRANDALL}_GET`, payload: 0 });
  }, [brandState.data]);

  return (
    <>
      <RDialog
        title="Add New Package"
        open={open}
        handleClose={() => setOpen(false)}
      >
        <Form
          defaultValues={defV}
          onSubmit={(data) => {
            const ACTION = data?.id ? `${BRAND}_PATCH` : `${BRAND}_POST`;
            dispatch({ type: ACTION, payload: data });
          }}
        />
      </RDialog>

      <Box sx={{ maxHeight: "87vh", overflow: "auto", p: 2 }}>
        <ActionBar
          hasPermission={user?.permissions?.includes("camera.add_camerabrand")}
          label="Brand"
          setOpen={() => { setDefV({}); setOpen(true) }}
          btnLabel="Add Brand"
        />

        <Card
          elevation={1}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            backgroundColor: "#f0f0f0",
            px: 2,
            py: 1,
            my: 2,
            borderRadius: 8,
          }}
        >
          <input
            inputRef={ref2}
            variant="outlined"
            size="small"
            placeholder="Search by title"
            fullWidth
          />
          <Button
            className="btn-primary"
            onClick={() => {
              dispatch({
                type: `${BRANDALL}_GET`,
                payload: `livesettings/0/?filter_by={"title":"${ref2.current.value}"}`,
              });
            }}
          >
            Search
          </Button>
        </Card>

        <Grid container spacing={2}>
          {brandallState?.data?.results?.map((data, index) => {
            data.image = "http://plotdlive.bglivepro.com/jpg/image.jpg";
            data.no_users = data?.users?.length;
            data.created_at = data.created_at?.split("T")?.[0]

            return (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                <InfoCard
                  keys={[
                    "",
                    "brand_name",
                    "",
                    "", "",
                    "created_at",
                  ]}
                  data={data}
                  onClick={() => {
                    //navigate("/timelapse-preview/", {})
                  }}
                  onAction={(action, data) => {
                    if (action === "Edit") {
                      setDefV(data);
                      setOpen(true);
                    } else if (action === "Delete") {
                      dispatch({
                        type: `${BRAND}_DELETE`,
                        payload: data?.id,
                      });
                    } else if (action == "Settings") {
                      navigate('/live-camera-settings/', { state: { brand: data } })
                    }
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.ceil(brandallState?.data?.count / pageSize)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      </Box>
    </>
  );
}
